import { FC, useRef, useState } from 'react';
import { Flex, IconButton, Text, Textarea, TextareaProps } from '@chakra-ui/react';
import { CheckIcon, CopyIcon } from '@chakra-ui/icons';

export const CodeTextarea: FC<TextareaProps> = (props) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const [hasCopied, setHasCopied] = useState(false);
  const copy = () => {
    if (textareaRef.current) {
      navigator.clipboard.writeText(textareaRef.current.value);
      setHasCopied(true);
      setTimeout(() => setHasCopied(false), 1000);
    }
  };
  return (
    <div>
      <Flex bg="neutral.100" align="center" borderTopRadius="default">
        <Text px={2}>Code</Text>
        <IconButton icon={hasCopied ? <CheckIcon /> : <CopyIcon />} aria-label="Copy" onClick={copy} ml="auto" />
      </Flex>
      <Textarea
        ref={textareaRef}
        readOnly
        fontFamily="mono"
        minHeight="min-content"
        height="min-content"
        sx={{ fieldSizing: 'content', borderTopRadius: 0 }}
        {...props}
      />
    </div>
  );
};
